import { updateField } from 'vuex-map-fields';

export default {
  START_LOADING_INSTANT_REPLIES(state) {
    state.loadingInstantReplies = true;
  },
  SET_INSTANT_REPLIES_LIST(state, payload) {
    state.instantReplyList = payload;
    state.loadingInstantReplies = false;
  },
  SET_INSTANT_REPLY(state, payload) {
    state.instantReply = payload;
  },
  INSTANT_REPLY_SAVED(state, payload) {
    state.instantReplySaved = payload;
  },
  INSTANT_REPLY_DELETED(state, payload) {
    state.instantReplyDeleted = payload;
  },
  INSTANT_REPLY_MESSAGE_DELETED(state, payload) {
    state.instantReplyMessageDeleted = payload;
  },
  SET_KEYWORD_ANALYTICS(state, payload) {
    state.keywordAnalytics = payload;
  },

  START_LOADING_RULES(state) {
    state.automationRulesLoaded = false;
  },
  SET_RULE_LIST(state, payload) {
    state.automationRules = payload;
    state.automationRulesLoaded = true;
  },
  AUTOMATION_RULE_SAVED(state, payload) {
    state.automationRuleSaved = payload;
  },
  AUTOMATION_RULE_DELETED(state, payload) {
    state.automationRuleDeleted = payload;
  },

  SET_AUTOMATION_SETTINGS(state, payload) {
    state.automationSettings = payload;
  },
  AUTOMATION_SETTINGS_SAVED(state, payload) {
    state.automationSettingsSaved = payload;
  },
  UNSUBSCRIBE_MESSAGE_SAVED(state, payload) {
    state.unsubscribeMessageSaved = payload;
  },
  UPDATE_UNSUBSCRIBED_MESSAGE(state, newMessage) {
    state.automationSettings.unsubscribe_message = newMessage;
  },
  FILE_UPLOADED(state, payload) {
    state.uploadedFile = payload;
  },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  FILE_UPLOAD_ERROR(state, payload) {
    state.fileUploadError = payload;
  },
  updateField,
};
